/**
 * Coupe l'auto-coloration de Prism.
 *
 * Prism colore de lui-même au chargement du document, avant que la barre de
 * titre ne soit posée. On préfère un seul passage, déclenché par code.js une
 * fois le DOM réarrangé. Ce fichier doit être importé AVANT `prismjs` : les
 * imports ES sont exécutés dans l'ordre de déclaration, d'où le fichier séparé.
 */
window.Prism = window.Prism || {};
window.Prism.manual = true;
